import axios from 'axios';

// Consulta de CNPJ pelo backend (/clientes/consulta-cnpj), que usa APIs públicas gratuitas
// (BrasilAPI, com MinhaReceita e ReceitaWS de reserva) e mantém cache.
// Retorna { dados } com os campos do cadastro de cliente, ou { erro } com a mensagem para o usuário.
// Nunca lança: o preenchimento automático não pode bloquear o cadastro manual.
export async function consultarCnpj(cnpj, apiBaseUrl, authHeader) {
  const numeros = (cnpj || '').replace(/\D/g, '');
  if (numeros.length !== 14) return { erro: 'CNPJ inválido' };

  try {
    const { data } = await axios.get(`${apiBaseUrl}/clientes/consulta-cnpj/${numeros}`, {
      ...authHeader,
      timeout: 30000,
    });
    return { dados: data };
  } catch (error) {
    console.error('Erro ao consultar CNPJ:', error);
    const mensagem = error.response?.data?.message;
    return { erro: mensagem || 'Não foi possível consultar o CNPJ. Preencha os dados manualmente.' };
  }
}
